'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ReoptimizationSaveService = function ReoptimizationSaveService($q, restangular, configurationService, momentService, $log, scenarioConstants, $rootScope, scenarioService, overridesSaveService) {
  var PRODUCTION_SCENARIO_NAME = scenarioConstants.PUBLISHED;
  function getMdReoptKey(keyRowData) {
    return {
      carrier: keyRowData.carrier,
      origin: keyRowData.origin,
      destination: keyRowData.destination,
      departureDate: keyRowData.departureDate,
      scenarioName: PRODUCTION_SCENARIO_NAME,
      userName: configurationService.getUserId(),
      reoptType: 'MD'
    };
  }
  function getNdReoptKey(keyRowData) {
    return {
      carrier: keyRowData.carrier,
      number: keyRowData.flightNumber,
      opsSuffix: keyRowData.opsSuffix,
      departureDate: momentService.copy(keyRowData.flightDepartureDateMoment, momentService.FIELD.ND_DEPARTURE_DATE).toISOString(),
      optGroupDate: keyRowData.optGroupDateMoment !== undefined ? momentService.copy(keyRowData.optGroupDateMoment, momentService.FIELD.OPT_GROUP_DATE).toISOString() : '',
      scenarioName: PRODUCTION_SCENARIO_NAME,
      userName: configurationService.getUserId(),
      sendRequested: 'N'
    };
  }
  function messageCallback(response) {
    if (!_.isEmpty(response)) {
      if (response.persistedCount > 0) {
        toastr.success('Optimized values saved');
        $rootScope.$broadcast('re-opt:publish-finished');
      } else if (response.failedCount > 0) {
        $log.error('ReoptimizationSaveService: Failed saving optimized values');
        toastr.error('Failed saving optimized values');
      }
      return response;
    }
  }
  function publishDocuments(restangularUrl, key, params) {
    return restangularUrl.customPUT(key, 'previewScenarioSave', params).then(messageCallback);
  }
  function ndReoptPublishDocuments(selectedRow, sendRequested) {
    var requestUrl = restangular.one('domain').one('flights');
    var flightNumberDateEventKey = getNdReoptKey(selectedRow);
    var params = {
      sendRequested: sendRequested
    };
    return publishDocuments(requestUrl, flightNumberDateEventKey, params);
  }
  function mdReoptPublishDocuments(keyRowData) {
    var requestUrl = restangular.one('domain').one('marketdemand');
    var marketDemandKey = getMdReoptKey(keyRowData);
    return publishDocuments(requestUrl, marketDemandKey);
  }
  function clearStalePreviewRequest(scenarioName) {
    return scenarioService.clearStalePreviewRequest(scenarioName);
  }
  function createPreviewScenario(scenarioName) {
    return scenarioService.createPreviewRequest(scenarioName);
  }
  function getUserScenarioName(scenarioName) {
    if (scenarioName === scenarioConstants.ND_PREVIEW_REQUEST) {
      return scenarioService.getCurrentUserNDPreviewRequestName();
    }
    if (scenarioName === scenarioConstants.MD_PREVIEW_REQUEST) {
      return scenarioService.getCurrentUserMDPreviewRequestName();
    }
    return scenarioName;
  }
  function saveOverridesData(saveDataArray, scenarioName) {
    var userScenarioName = getUserScenarioName(scenarioName);
    return saveDataArray.reduce(function (accumulatorPromise, saveData) {
      return accumulatorPromise.then(function () {
        return overridesSaveService.saveOverrides(saveData.data, saveData.gridId, userScenarioName);
      });
    }, $q.when([]));
  }
  function saveDataBeforeReoptPrev(saveDataArray, scenarioName) {
    return clearStalePreviewRequest(scenarioName).then(function () {
      return createPreviewScenario(scenarioName);
    }).then(function () {
      return saveOverridesData(saveDataArray, scenarioName);
    });
  }
  return {
    mdReoptPublishDocuments: mdReoptPublishDocuments,
    ndReoptPublishDocuments: ndReoptPublishDocuments,
    clearStalePreviewRequest: clearStalePreviewRequest,
    createPreviewScenario: createPreviewScenario,
    saveOverridesData: saveOverridesData,
    saveDataBeforeReoptPrev: saveDataBeforeReoptPrev
  };
};
ReoptimizationSaveService.$inject = ['$q', 'Restangular', 'ConfigurationService', 'MomentService', '$log', 'ScenarioConstants', '$rootScope', 'ScenarioService', 'OverridesSaveService'];
module.exports = ReoptimizationSaveService;